{
	"RESPONSIVE_%1_ALL_ODDS_META_DESCRIPTION": "Get the best available %1 odds from all online bookmakers with Oddschecker, the home of betting value.",
	"RESPONSIVE_%1_COMPETITIONS": "%1 Competitions",
	"RESPONSIVE_%1_GUIDES": "RESPONSIVE_%1_GUIDES",
	"RESPONSIVE_%1_HANDICAPPERS_PICKS": "%1's Picks",
	"RESPONSIVE_%1_LEAGUE_TABLE": "%1 Table",
	"RESPONSIVE_%1_MATCHES": "%1 Matches",
	"RESPONSIVE_%1_NEWS": "%1 News",
	"RESPONSIVE_%1_OFFERS_NUMBER_FILTER": "RESPONSIVE_%1_OFFERS_NUMBER_FILTER",
	"RESPONSIVE_%1_RUNNERS": "%1 Runners",
	"RESPONSIVE_%1_SPORT_HOME": "%1 Home",
	"RESPONSIVE_%1_TERMS": "%1 T&C's:",
	"RESPONSIVE_%1_TIPS": "%1 Tips",
	"RESPONSIVE_10_STAKE_RETURNS": "A $10 stake could return ${0}",
	"RESPONSIVE_ABANDONED": "Abandoned",
	"RESPONSIVE_ABOUTUS_URL": "about-us",
	"RESPONSIVE_ABOUT_FREE_BETS": "ABOUT FREE BETs",
	"RESPONSIVE_ABOUT_US": "About Us",
	"RESPONSIVE_ACCA_BET_SLIP": "Multi Bet Slip",
	"RESPONSIVE_ACCESSING_FROM": "Accessing from outside ",
	"RESPONSIVE_ACCOUNT": "Account",
	"RESPONSIVE_ACCOUNT_DETAILS": "Account Details",
	"RESPONSIVE_ADDED_TO_BETSLIP": "Added To Betslip",
	"RESPONSIVE_ADD_ALL_TO_BET_SLIP": "RESPONSIVE_ADD_ALL_TO_BET_SLIP",
	"RESPONSIVE_ADD_BET_AMOUNT": "Add Bet Amount",
	"RESPONSIVE_ADD_MORE_SELECTIONS": "Add More Selections",
	"RESPONSIVE_ADD_TEAM_ODDS": "Add Team %1 Odds",
	"RESPONSIVE_ADD_TO_BET_SLIP": "Add to Bet Slip / Add to Multi",
	"RESPONSIVE_AGE_VERIFICATION_COOKIES_POLICY": "RESPONSIVE_AGE_VERIFICATION_COOKIES_POLICY",
	"RESPONSIVE_AGE_VERIFICATION_PROCEED": "RESPONSIVE_AGE_VERIFICATION_PROCEED",
	"RESPONSIVE_AGE_VERIFICATION_SUBTITLE": "RESPONSIVE_AGE_VERIFICATION_SUBTITLE",
	"RESPONSIVE_AGE_VERIFICATION_TEXT": "RESPONSIVE_AGE_VERIFICATION_TEXT",
	"RESPONSIVE_AGE_VERIFICATION_TITLE": "RESPONSIVE_AGE_VERIFICATION_TITLE",
	"RESPONSIVE_ALL": "All",
	"RESPONSIVE_ALL_%1_NEWS": "All %1 News",
	"RESPONSIVE_ALL_%1_TIPS": "All %1 Tips",
	"RESPONSIVE_ALL_BETTING_MARKETS": "All Betting Markets",
	"RESPONSIVE_ALL_BOOKIES_ARE": "All Bookies Are:",
	"RESPONSIVE_ALL_COMPETITIONS": "All Competitions",
	"RESPONSIVE_ALL_CUSTOMERS": "Promotions",
	"RESPONSIVE_ALL_FREE_BETS": "All Free Bets",
	"RESPONSIVE_ALL_GAMES": "ALL GAMES",
	"RESPONSIVE_ALL_HANDICAPPERS": "All Handicappers",
	"RESPONSIVE_ALL_LEAGUES": "all-leagues",
	"RESPONSIVE_ALL_LEAGUES_BUTTON": "All {0}",
	"RESPONSIVE_ALL_LEAGUES_FIXTURES": "All {0} fixtures",
	"RESPONSIVE_ALL_MARKETS": "All Markets",
	"RESPONSIVE_ALL_NEWS": "All News",
	"RESPONSIVE_ALL_ODDS": "All Odds",
	"RESPONSIVE_ALL_SPORTS": "All Sports",
	"RESPONSIVE_ALL_STATES": "All States",
	"RESPONSIVE_ALL_TIPS": "All Tips",
	"RESPONSIVE_ALMOST_THERE": "Almost there",
	"RESPONSIVE_ALREADY_A_MEMBER": "Already a member?",
	"RESPONSIVE_AMERICAN_FOOTBALL": "Football",
	"RESPONSIVE_AMERICAN_ODDS": "American Odds",
	"RESPONSIVE_AND_OUR": "and our",
	"RESPONSIVE_ANOTHER_PASSWORD": "Forgotten your password? Tap here to get another",
	"RESPONSIVE_APPLY_FILTERS": "Apply Filters",
	"RESPONSIVE_APP_CTA": "View",
	"RESPONSIVE_APP_DOWNLOAD_SITE": "oddschecker.com.au",
	"RESPONSIVE_APP_DOWNLOAD_TEXT_ANDROID": "Free - Click to Download!",
	"RESPONSIVE_APP_DOWNLOAD_TEXT_IOS": "Free - On the App Store",
	"RESPONSIVE_APP_TITLE": "Oddschecker",
	"RESPONSIVE_ARIA_LABEL_OFFER_SHOW_LESS": "RESPONSIVE_ARIA_LABEL_OFFER_SHOW_LESS",
	"RESPONSIVE_ARIA_LABEL_OFFER_SHOW_MORE": "RESPONSIVE_ARIA_LABEL_OFFER_SHOW_MORE",
	"RESPONSIVE_AT": "at",
	"RESPONSIVE_AUS_%1": "Australia & New Zealand %1",
	"RESPONSIVE_AUTH_ACCOUNT_NOT_VERIFIED": "RESPONSIVE_AUTH_ACCOUNT_NOT_VERIFIED",
	"RESPONSIVE_AUTH_ALREADY_A_MEMBER": "RESPONSIVE_AUTH_ALREADY_A_MEMBER",
	"RESPONSIVE_AUTH_CHECK_EMAIL": "RESPONSIVE_AUTH_CHECK_EMAIL",
	"RESPONSIVE_AUTH_CONTINUE": "RESPONSIVE_AUTH_CONTINUE",
	"RESPONSIVE_AUTH_CONTINUE_USING_ODDSCHECKER": "RESPONSIVE_AUTH_CONTINUE_USING_ODDSCHECKER",
	"RESPONSIVE_AUTH_EMAIL_ADDRESS": "RESPONSIVE_AUTH_EMAIL_ADDRESS",
	"RESPONSIVE_AUTH_EMAIL_ADDRESS_FORMAT": "RESPONSIVE_AUTH_EMAIL_ADDRESS_FORMAT",
	"RESPONSIVE_AUTH_EXCLUSIVE_OFFERS": "RESPONSIVE_AUTH_EXCLUSIVE_OFFERS",
	"RESPONSIVE_AUTH_FORGOT_PASSWORD": "RESPONSIVE_AUTH_FORGOT_PASSWORD",
	"RESPONSIVE_AUTH_FREE_BETS": "RESPONSIVE_AUTH_FREE_BETS",
	"RESPONSIVE_AUTH_FREE_PICKS": "RESPONSIVE_AUTH_FREE_PICKS",
	"RESPONSIVE_AUTH_INPUT_EMAIL": "RESPONSIVE_AUTH_INPUT_EMAIL",
	"RESPONSIVE_AUTH_INPUT_PASSWORD": "RESPONSIVE_AUTH_INPUT_PASSWORD",
	"RESPONSIVE_AUTH_I_HAVE_READ_TANDC_AND_PRIVACY_POLICY": "RESPONSIVE_AUTH_I_HAVE_READ_TANDC_AND_PRIVACY_POLICY",
	"RESPONSIVE_AUTH_KEEP_ME_LOGGED_IN": "RESPONSIVE_AUTH_KEEP_ME_LOGGED_IN",
	"RESPONSIVE_AUTH_LOADING": "RESPONSIVE_AUTH_LOADING",
	"RESPONSIVE_AUTH_LOGIN": "RESPONSIVE_AUTH_LOGIN",
	"RESPONSIVE_AUTH_LOGIN_FAILED": "RESPONSIVE_AUTH_LOGIN_FAILED",
	"RESPONSIVE_AUTH_LOGIN_SUCCESS": "RESPONSIVE_AUTH_LOGIN_SUCCESS",
	"RESPONSIVE_AUTH_LOGIN_TO_ODDSCHECKER": "RESPONSIVE_AUTH_LOGIN_TO_ODDSCHECKER",
	"RESPONSIVE_AUTH_LOGIN_WITH_FACEBOOK": "RESPONSIVE_AUTH_LOGIN_WITH_FACEBOOK",
	"RESPONSIVE_AUTH_LOGIN_WITH_GOOGLE": "RESPONSIVE_AUTH_LOGIN_WITH_GOOGLE",
	"RESPONSIVE_AUTH_NEW_SIGN_UP_REASONS": "RESPONSIVE_AUTH_NEW_SIGN_UP_REASONS",
	"RESPONSIVE_AUTH_NOT_A_MEMBER": "RESPONSIVE_AUTH_NOT_A_MEMBER",
	"RESPONSIVE_AUTH_OC_USES_COOKIES": "RESPONSIVE_AUTH_OC_USES_COOKIES",
	"RESPONSIVE_AUTH_PASSWORD": "RESPONSIVE_AUTH_PASSWORD",
	"RESPONSIVE_AUTH_PASSWORD_ERROR_MAX": "RESPONSIVE_AUTH_PASSWORD_ERROR_MAX",
	"RESPONSIVE_AUTH_PASSWORD_ERROR_MIN": "RESPONSIVE_AUTH_PASSWORD_ERROR_MIN",
	"RESPONSIVE_AUTH_PASSWORD_ONLY_SYMBOLS_NOT_ALLOWED": "RESPONSIVE_AUTH_PASSWORD_ONLY_SYMBOLS_NOT_ALLOWED",
	"RESPONSIVE_AUTH_PLEASE_ENTER_VALID_CREDENTIALS": "RESPONSIVE_AUTH_PLEASE_ENTER_VALID_CREDENTIALS",
	"RESPONSIVE_AUTH_REGISTRATION_COMPLETE": "RESPONSIVE_AUTH_REGISTRATION_COMPLETE",
	"RESPONSIVE_AUTH_RESEND_EMAIL": "RESPONSIVE_AUTH_RESEND_EMAIL",
	"RESPONSIVE_AUTH_RESET_PASSWORD": "RESPONSIVE_AUTH_RESET_PASSWORD",
	"RESPONSIVE_AUTH_RESET_PASSWORD_ACTION": "RESPONSIVE_AUTH_RESET_PASSWORD_ACTION",
	"RESPONSIVE_AUTH_RESET_PASSWORD_INSTRUCTIONS": "RESPONSIVE_AUTH_RESET_PASSWORD_INSTRUCTIONS",
	"RESPONSIVE_AUTH_RESET_PASSWORD_THANK_YOU": "RESPONSIVE_AUTH_RESET_PASSWORD_THANK_YOU",
	"RESPONSIVE_AUTH_RETURN_TO_LOGIN": "RESPONSIVE_AUTH_RETURN_TO_LOGIN",
	"RESPONSIVE_AUTH_SIGNUP_FAILED": "RESPONSIVE_AUTH_SIGNUP_FAILED",
	"RESPONSIVE_AUTH_SIGNUP_SUCCESS": "RESPONSIVE_AUTH_SIGNUP_SUCCESS",
	"RESPONSIVE_AUTH_SIGN_UP": "RESPONSIVE_AUTH_SIGN_UP",
	"RESPONSIVE_AUTH_SIGN_UP_NOW": "RESPONSIVE_AUTH_SIGN_UP_NOW",
	"RESPONSIVE_AUTH_SIGN_UP_TO_ODDSCHECKER": "RESPONSIVE_AUTH_SIGN_UP_TO_ODDSCHECKER",
	"RESPONSIVE_AUTH_SIGN_UP_WITH_FACEBOOK": "RESPONSIVE_AUTH_SIGN_UP_WITH_FACEBOOK",
	"RESPONSIVE_AUTH_SIGN_UP_WITH_GOOGLE": "RESPONSIVE_AUTH_SIGN_UP_WITH_GOOGLE",
	"RESPONSIVE_AUTH_WELCOME_BACK_TO_ODDSCHECKER": "RESPONSIVE_AUTH_WELCOME_BACK_TO_ODDSCHECKER",
	"RESPONSIVE_AUTH_WE_HAVE_UPDATED_TANDC": "RESPONSIVE_AUTH_WE_HAVE_UPDATED_TANDC",
	"RESPONSIVE_AUTH_WHY_DO_WE_NEED_THIS": "RESPONSIVE_AUTH_WHY_DO_WE_NEED_THIS",
	"RESPONSIVE_AUTH_WHY_DO_WE_NEED_THIS_SOCIAL_AUTH": "RESPONSIVE_AUTH_WHY_DO_WE_NEED_THIS_SOCIAL_AUTH",
	"RESPONSIVE_AUTH_WITH_US_YOU_CAN_COMPARE_CHOOSE_AND_PLAY": "RESPONSIVE_AUTH_WITH_US_YOU_CAN_COMPARE_CHOOSE_AND_PLAY",
	"RESPONSIVE_AUTH_YES_TO_MARKETING": "RESPONSIVE_AUTH_YES_TO_MARKETING",
	"RESPONSIVE_AWAY": "Away",
	"RESPONSIVE_AWAY_DRAW": "X2",
	"RESPONSIVE_AWAY_USA": "Away",
	"RESPONSIVE_BACK": "Back",
	"RESPONSIVE_BACK_TO_TOP": "RESPONSIVE_BACK_TO_TOP",
	"RESPONSIVE_BASKETBALL": "Basketball",
	"RESPONSIVE_BEST_BOOK_INFO": "A list of betting markets which have the lowest over-round or book percentage figure, therefore the best margin for the punter. Excludes exchange Odds.",
	"RESPONSIVE_BEST_CURRENT_ODDS": "Best Current Odds",
	"RESPONSIVE_BEST_ODDS": "Best Odds",
	"RESPONSIVE_BEST_ODDS_ARE_IN": "Best odds are in:",
	"RESPONSIVE_BEST_ORIGINAL_ODDS": "Best Original Odds",
	"RESPONSIVE_BET": "Bet",
	"RESPONSIVE_BETS": "Bets",
	"RESPONSIVE_BETSLIP": "Betslip",
	"RESPONSIVE_BETSLIP_MULTI": "Parlay Betslip",
	"RESPONSIVE_BETSLIP_SINGLE": "Straight Betslip",
	"RESPONSIVE_BETS_FOR": "Betting",
	"RESPONSIVE_BETS_MENU": "Bets",
	"RESPONSIVE_BETTING_GUIDES": "Betting Guides",
	"RESPONSIVE_BETTING_GUIDES_INSTAGRAM": "RESPONSIVE_BETTING_GUIDES_INSTAGRAM",
	"RESPONSIVE_BETTING_GUIDES_TWITTER": "RESPONSIVE_BETTING_GUIDES_TWITTER",
	"RESPONSIVE_BETTING_GUIDES_URL": "<a title=\"Your Complete Guides to Sports Betting\" target=\"_blank\" href=\"https://www.stg.occloud.io/us/betting-guides\">Your Complete Guides to Sports Betting</a>",
	"RESPONSIVE_BETTING_MARKETS": "betting-markets",
	"RESPONSIVE_BETTING_MARKETS_TITLE": "Betting Markets",
	"RESPONSIVE_BETTING_NEWS_TIPS": "Betting News & Tips",
	"RESPONSIVE_BETTING_ODDS": "Betting Odds",
	"RESPONSIVE_BETTING_ODDS_H1": "%1 Betting Odds",
	"RESPONSIVE_BETTING_ODDS_META": "%1 Betting Odds | %2 | Oddschecker",
	"RESPONSIVE_BETTING_OFFERS": "Betting Offers",
	"RESPONSIVE_BETTING_TIPS": "Betting Tips",
	"RESPONSIVE_BET_AMOUNT": "Bet Amount",
	"RESPONSIVE_BET_NO": "No",
	"RESPONSIVE_BET_NOW": "Bet Now",
	"RESPONSIVE_BET_ODDS": "Bet #%1 Odds",
	"RESPONSIVE_BET_ON": "bet on",
	"RESPONSIVE_BET_ON_BOOKMAKER_WEBSITE": "Bet with Sportsbook",
	"RESPONSIVE_BET_SLIP_EMPTY": "Bet Slip Empty",
	"RESPONSIVE_BET_TYPE_GROUP_0": "Popular Markets",
	"RESPONSIVE_BET_TYPE_GROUP_1": "Win Markets",
	"RESPONSIVE_BET_TYPE_GROUP_2": "Stats Markets",
	"RESPONSIVE_BET_TYPE_GROUP_3": "Player Markets",
	"RESPONSIVE_BET_TYPE_GROUP_3_TO_OVERWRITE": "Player Props",
	"RESPONSIVE_BET_TYPE_GROUP_4": "Score Markets",
	"RESPONSIVE_BET_TYPE_GROUP_5": "Group Markets",
	"RESPONSIVE_BET_TYPE_GROUP_6": "Other Markets",
	"RESPONSIVE_BET_TYPE_GROUP_7": "Spread Betting Markets",
	"RESPONSIVE_BET_TYPE_GROUP_8": "Handicap Markets",
	"RESPONSIVE_BET_TYPE_GROUP_DEFAULT": "More Markets",
	"RESPONSIVE_BET_WITH": "BET WITH",
	"RESPONSIVE_BET_WITH_BOOKIE": "Bet With This Bookie",
	"RESPONSIVE_BET_YES": "Yes",
	"RESPONSIVE_BIG_EVENTS": "Big Events",
	"RESPONSIVE_BLOCKED_COUNTRY_MESSAGE": "Visiting from Italy? You'll need to use our Italian site in order to have access to Oddschecker. You can use the link below.",
	"RESPONSIVE_BLOG_HEADER_TEXT": "RESPONSIVE_BLOG_HEADER_TEXT",
	"RESPONSIVE_BLOG_PROJECT_OF": "RESPONSIVE_BLOG_PROJECT_OF",
	"RESPONSIVE_BOLD": "Bold",
	"RESPONSIVE_BONUS_BETS": "Bonus Bets",
	"RESPONSIVE_BONUS_BETS_EXPIRED": "Offer expired",
	"RESPONSIVE_BONUS_BETS_HOME": "All Bonus Bets",
	"RESPONSIVE_BONUS_BETS_RECOMMENDED": "Recommended",
	"RESPONSIVE_BONUS_BETS_SPECIAL_OFFERS": "Bonus Bets & Special Offers",
	"RESPONSIVE_BONUS_BETS_TERMS_APPLY": "T&C's apply",
	"RESPONSIVE_BONUS_BETS_TITLE": "<b>NJ</b> Offerz (shown by default)",
	"RESPONSIVE_BONUS_BETS_TITLE_GEO_LOCATION": "<b>%</b> Betting Offers",
	"RESPONSIVE_BONUS_BUTTON_TITLE": "Bonus",
	"RESPONSIVE_BONUS_BUTTON_VALUE": "$10",
	"RESPONSIVE_BONUS_TERMS": "New acc only, exc NSW, SA, WA & VIC. Turnover requirements & expiry period apply. See T&C’s on website. Gamble responsibly.",
	"RESPONSIVE_BOOKIE": "Bookie",
	"RESPONSIVE_BOOKIE_CHANGE_SUCCESS": "Exclusive offers and free bets preferences updated",
	"RESPONSIVE_BOOKIE_MONTH": "Bookmaker of the month",
	"RESPONSIVE_BOOKIE_REVIEW_QUICK_LINKS_HEADER": "RESPONSIVE_BOOKIE_REVIEW_QUICK_LINKS_HEADER",
	"RESPONSIVE_BOOKMAKERS": "Bookmakers",
	"RESPONSIVE_BOOKMAKERS_REVIEWS": "Bookmaker Reviews",
	"RESPONSIVE_BROWSER_ERROR": "Browser error",
	"RESPONSIVE_BY_SIGNING_UP": "By signing up you agree to our",
	"RESPONSIVE_CALCULATE": "Calculate",
	"RESPONSIVE_CANCEL": "Cancel",
	"RESPONSIVE_CARDS_META_DESCRIPTION": "View all available outright and match odds, plus get news, tips, free bets and money-back offers. All you need to bet.",
	"RESPONSIVE_CASINO_NAV_TITLE": "Casino Offers",
	"RESPONSIVE_CASINO_STATS_1": "Casino",
	"RESPONSIVE_CASINO_STATS_2": "Desktop",
	"RESPONSIVE_CASINO_STATS_3": "Mobile",
	"RESPONSIVE_CASINO_STATS_4": "Bonuses",
	"RESPONSIVE_CASINO_TITLE": "Casino",
	"RESPONSIVE_CHANGE": "Change",
	"RESPONSIVE_CHANGE_BOOKMAKER": "Change Bookmaker",
	"RESPONSIVE_CHANGE_GROUP": " Change Group",
	"RESPONSIVE_CHANGE_LEAGUE": "Change League",
	"RESPONSIVE_CHANGE_MARKET": "Change Market",
	"RESPONSIVE_CHANGE_MATCH": "Change Matchups",
	"RESPONSIVE_CHANGE_RACE": "Change Race",
	"RESPONSIVE_CHANGE_STATE": "Change state",
	"RESPONSIVE_CHANGE_TEAM": "Change Team",
	"RESPONSIVE_CHANGE_TRACK": "Change Track",
	"RESPONSIVE_CLAIM": "Claim",
	"RESPONSIVE_CLAIM_ALL": "Test All",
	"RESPONSIVE_CLAIM_NEW": "Test New",
	"RESPONSIVE_CLAIM_NOW": "Claim now",
	"RESPONSIVE_CLAIM_NOW_ALL": "Claim Offer",
	"RESPONSIVE_CLAIM_NOW_NEW": "TestNnew",
	"RESPONSIVE_CLAIM_OFFER": "CLAIM OFFER",
	"RESPONSIVE_CLAIM_OFFER_ON": "SIGN UP NOW",
	"RESPONSIVE_CLAIM_THIS_OFFER_NOW": "CLAIM THIS OFFER NOW",
	"RESPONSIVE_CLEAR": "Clear",
	"RESPONSIVE_CLOSE": "Close",
	"RESPONSIVE_CLOSE_ACCOUNT_WINDOW": "Close Window",
	"RESPONSIVE_CLOSE_BETSLIP": "Close Betslip",
	"RESPONSIVE_COMPARE": "Compare",
	"RESPONSIVE_COMPARE_BOOKIES": "Compare and Choose a Bookmaker",
	"RESPONSIVE_COMPARE_ODDS": "COMPARE ODDS",
	"RESPONSIVE_COMPETITION_OUTRIGHTS_%1": "%1 Outrights",
	"RESPONSIVE_CONFIRMATION_EMAIL_SENT": "Confirmation e-mail sent",
	"RESPONSIVE_CONFIRM_EMAIL_TITLE": "Please confirm your e-mail address",
	"RESPONSIVE_CONFIRM_PASSWORD": "Confirm Password",
	"RESPONSIVE_CONFIRM_YOUR_EMAIL": "Please confirm your e-mail address",
	"RESPONSIVE_CONTACT_PREFERENCES": "Contact Preferences",
	"RESPONSIVE_CONTACT_US": "Contact Us",
	"RESPONSIVE_CONTINUE_TO_ITALY": "Continue to Italy",
	"RESPONSIVE_CONTRACT_PREFERENCES": "Contact Preferences",
	"RESPONSIVE_COOKIE_POLICY": "By using our online products or closing this message you are agreeing to our",
	"RESPONSIVE_COOKIE_POLICY_ACCEPT": "Accept & Close",
	"RESPONSIVE_COOKIE_POLICY_LINK": "Cookie Policy",
	"RESPONSIVE_COPIED": "COPIED",
	"RESPONSIVE_COPY_LINK": "Copy link",
	"RESPONSIVE_COUNTRY_AUSTRALIA": "Australia",
	"RESPONSIVE_COUNTRY_BANNER_1": "We can direct you to the best site based on your location",
	"RESPONSIVE_COUNTRY_BANNER_2": "Please select a location to view this site",
	"RESPONSIVE_COUNTRY_COLOMBIA": "Colombia",
	"RESPONSIVE_COUNTRY_DENMARK": "Denmark",
	"RESPONSIVE_COUNTRY_GERMANY": "Germany",
	"RESPONSIVE_COUNTRY_ITALY": "Italy",
	"RESPONSIVE_COUNTRY_SPAIN": "Spain",
	"RESPONSIVE_COUNTRY_UK": "United Kingdom",
	"RESPONSIVE_COUNTRY_US": "United States",
	"RESPONSIVE_CURRENCY_SYMBOL": "$",
	"RESPONSIVE_CUSTOMERTYPE_ALL": "RESPONSIVE_CUSTOMERTYPE_ALL",
	"RESPONSIVE_CUSTOMERTYPE_NEW": "RESPONSIVE_CUSTOMERTYPE_NEW",
	"RESPONSIVE_DATE_FORMAT": "Day Date Month Year/ Sat 5th Apr 2016",
	"RESPONSIVE_DECIMAL_ODDS": "Decimal Odds",
	"RESPONSIVE_DELETE_ALL": "Delete all",
	"RESPONSIVE_DOWNLOAD_APP": "Download",
	"RESPONSIVE_DOWNLOAD_APP_ANDROID": "Download for Android",
	"RESPONSIVE_DOWNLOAD_APP_IOS": "Download on the App Store",
	"RESPONSIVE_DOWNLOAD_APP_TITLE": "Download the Official Oddschecker App",
	"RESPONSIVE_DRAW": "Draw",
	"RESPONSIVE_DRAW_USA": "Draw",
	"RESPONSIVE_DRIFTER_INFO": "Selections in a betting market whose odds have lengthened, suggesting they have not been backed or the odds were too short. Excludes exchange Odds.",
	"RESPONSIVE_EACH_WAY_TERMS": "Each-Way Terms",
	"RESPONSIVE_EDIT": "Edit",
	"RESPONSIVE_EMAIL_ADDRESS": "Email Address",
	"RESPONSIVE_EMAIL_ADDRESS_FORMAT": "Please add a valid e-mail format",
	"RESPONSIVE_EMAIL_CONFIRMED_SUBTITLE": "Log in",
	"RESPONSIVE_EMAIL_CONFIRMED_TITLE": "E-mail confirmed!",
	"RESPONSIVE_EMAIL_EXISTS": "Email address already exists",
	"RESPONSIVE_EMAIL_INVALID": "Email address invalid",
	"RESPONSIVE_EMAIL_PASSWORD": "Enter your email address below and we will send you a replacement password",
	"RESPONSIVE_EMPTY_EVENT": "Sorry, we could not locate the page you were looking for. It is possible the page requested relates to a past event and therefore no longer exists. Please use the links on the left to navigate to another event",
	"RESPONSIVE_ERROR": "ERROR",
	"RESPONSIVE_ESTIMATED_READ_TIME": "Estimated Read Time: %1",
	"RESPONSIVE_EVENT_LIVE_AT": "Live at",
	"RESPONSIVE_EVENT_STARTS_IN": "Starts in",
	"RESPONSIVE_EXCHANGE": "Exchange",
	"RESPONSIVE_EXPERT_PICKS": "Expert Picks",
	"RESPONSIVE_EXPERT_PICKS_URL": "<a title=\"Picks\" target=\"_blank\" href=\"https://www.stg.occloud.io/us/picks-parlays\">Picks</a>",
	"RESPONSIVE_EXPIRES_IN": "Expires in %1",
	"RESPONSIVE_EXPIRES_IN_%1_DAY": "Expires in %1 day",
	"RESPONSIVE_EXPIRES_IN_%1_DAYS": "Expires in %1 days",
	"RESPONSIVE_EXPIRES_SOON": "Expires Soon",
	"RESPONSIVE_EXPLORE_ALL_ARTICLES": "Explore All Articles",
	"RESPONSIVE_EXPLORE_FREE_BETS": "Explore Free Bets",
	"RESPONSIVE_FAILED_EMAIL": "Failed to send email",
	"RESPONSIVE_FAST_WITHDRAWALS": "Fast Withdrawals",
	"RESPONSIVE_FAVOURITE": "FAV",
	"RESPONSIVE_FAVOURITE_SORT": "Favourite",
	"RESPONSIVE_FEATURED_MATCHES": "Soccer Betting Odds",
	"RESPONSIVE_FEATURED_STATES": "Featured States",
	"RESPONSIVE_FEATURED_TIP": "Featured",
	"RESPONSIVE_FEATURED_TIPS": "Featured Tips",
	"RESPONSIVE_FILTERS_DONE": "RESPONSIVE_FILTERS_DONE",
	"RESPONSIVE_FILTER_1": "is Risk Free",
	"RESPONSIVE_FILTER_2": "matchedBonus",
	"RESPONSIVE_FILTER_3": "no Deposit",
	"RESPONSIVE_FIND_OUT_MORE": "SUBSCRIBE NOW",
	"RESPONSIVE_FINISHED": "Finished",
	"RESPONSIVE_FIXTURES": "Top Competitions",
	"RESPONSIVE_FOOTBALL": "Soccer",
	"RESPONSIVE_FOOTER_LEGAL": "DISCLAIMER: This site is 100% for entertainment purposes only and does not involve real money betting. Gambling can be addictive, please play responsibly. If you or someone you know has a gambling problem and wants help, call 1-800 GAMBLER in the U.S",
	"RESPONSIVE_FORGOTTEN_PASSWORD": "Forgotten Password",
	"RESPONSIVE_FORGOT_PASSWORD": "If your email has been registered, you'll see a link to reset your password from us in your inbox.",
	"RESPONSIVE_FORM_ERROR": "The form has errors",
	"RESPONSIVE_FRACTIONAL_ODDS": "Fractional Odds",
	"RESPONSIVE_FREE_BETS": "Bonus Bets",
	"RESPONSIVE_FREE_BETS_FILTER_DROPDOWN": "State you are betting from:",
	"RESPONSIVE_FREE_BETS_FILTER_SELECT_STATE": "Select State",
	"RESPONSIVE_FREE_BETS_MENU": "Free Bets",
	"RESPONSIVE_FREE_BETS_NAV_TITLE": "All Free Bet Offers",
	"RESPONSIVE_FREE_BETS_TITLE": "FREE BETS",
	"RESPONSIVE_FREE_BETS_URL": "<a title=\"Top Free Bets for Sportsbook\" target=\"_blank\" href=\"https://www.stg.occloud.io/us/free-bets\">Top Free Bets for Sportsbook</a>",
	"RESPONSIVE_FUTURES": "Futures",
	"RESPONSIVE_GAMES": "Games",
	"RESPONSIVE_GDPR_ACCEPT_AND_CLOSE": "Accept and Close",
	"RESPONSIVE_GDPR_PLEASE_ACCEPT_OUR_POLICIES": "Please accept our T&C Policy",
	"RESPONSIVE_GET_IN_TOUCH": "Get in Touch",
	"RESPONSIVE_GET_NEW_LINK": "GET NEW LINK",
	"RESPONSIVE_GET_OFFER": "Get offer",
	"RESPONSIVE_GO_TO": "Go To",
	"RESPONSIVE_GO_TO_EVENT": "GO TO EVENT",
	"RESPONSIVE_GO_TO_HOMEPAGE": "Go To Homepage",
	"RESPONSIVE_GO_TO_MATCH": "Go To Match",
	"RESPONSIVE_GREYHOUNDS": "Greyhounds",
	"RESPONSIVE_GRID_DISCLAIMER_TEXT": "Odds shown come direct from online bookmakers. Please check all aspects of your bets before placement.",
	"RESPONSIVE_GROUPS": "Groups",
	"RESPONSIVE_GROUP_FIXTURES": "Fixtures",
	"RESPONSIVE_HANDBALL": "RESPONSIVE_HANDBALL",
	"RESPONSIVE_HANDICAP": "Handicap",
	"RESPONSIVE_HANDICAPPERS_RECORD": "Handicapper's Record",
	"RESPONSIVE_HANDICAPPER_ANALYSIS": "Handicapper Analysis",
	"RESPONSIVE_HARNESS_RACING": "Harness Racing",
	"RESPONSIVE_HEADER_10_STAKE_RETURNS": "$10 Returns",
	"RESPONSIVE_HELP": "Help",
	"RESPONSIVE_HELPFUL_LINKS": "Helpful Links",
	"RESPONSIVE_HERE": "here",
	"RESPONSIVE_HOME": "Home",
	"RESPONSIVE_HOMEPAGE": "Homepage",
	"RESPONSIVE_HOME_AWAY": "12",
	"RESPONSIVE_HOME_BREADCRUMB": "RESPONSIVE_HOME_BREADCRUMB",
	"RESPONSIVE_HOME_DRAW": "1X",
	"RESPONSIVE_HOME_DRAW_AWAY": "Home / Draw / Away",
	"RESPONSIVE_HOME_PAGE_TITLE": "Compare odds, read tips, place bets",
	"RESPONSIVE_HOME_USA": "Home",
	"RESPONSIVE_HORSE_RACING": "Horse Racing",
	"RESPONSIVE_HOW_TO_CLAIM": "How to claim",
	"RESPONSIVE_ICE_HOCKEY": "Hockey",
	"RESPONSIVE_INITIAL_ODDS": "Initial Odds",
	"RESPONSIVE_INPUT_CONFIRM_PASSWORD": "Confirm Password",
	"RESPONSIVE_INPUT_PASSWORD": "Insert Password",
	"RESPONSIVE_INSIGHTS_URL": "<a title=\"Insights\" target=\"_blank\" href=\"https://www.stg.occloud.io/us/insight/specials/other-sports/20220831-introducing-myoc-premium?ocpremium\">MyOC Premium Pricing</a>",
	"RESPONSIVE_INT_%1": "International %1",
	"RESPONSIVE_INVALID_CREDENTIALS": "Email and password not recognised",
	"RESPONSIVE_INVALID_EMAIL": "Invalid E-mail",
	"RESPONSIVE_INVALID_USERNAME": "Invalid username",
	"RESPONSIVE_IN_PLAY": "In Play",
	"RESPONSIVE_LATEST_ARTICLES": "Latest Articles",
	"RESPONSIVE_LATEST_PICKS": "Latest Picks",
	"RESPONSIVE_LATEST_PICKS_ARTICLES": "Latest Picks Articles",
	"RESPONSIVE_LATEST_PICKS_ARTICLES_CTA": "View Picks Hub",
	"RESPONSIVE_LATEST_SPORT_PICKS_ARTICLES": "Latest %1 Picks Articles",
	"RESPONSIVE_LATEST_TIPS": "Latest betting tips",
	"RESPONSIVE_LEAGUES": "Leagues & cups",
	"RESPONSIVE_LEAGUE_TABLE": "League Table",
	"RESPONSIVE_LEAGUE_TABLE_DRAW": "Draw",
	"RESPONSIVE_LEAGUE_TABLE_DRAW_SHORT": "D",
	"RESPONSIVE_LEAGUE_TABLE_FORM": "Form",
	"RESPONSIVE_LEAGUE_TABLE_KEY": "Key",
	"RESPONSIVE_LEAGUE_TABLE_LOST": "Lost",
	"RESPONSIVE_LEAGUE_TABLE_LOST_SHORT": "L",
	"RESPONSIVE_LEAGUE_TABLE_META_DESCRIPTION": "View the latest {x1} table to see who is leading the way & who might be relegated with Oddschecker. Plus access to other league tables across the globe. ",
	"RESPONSIVE_LEAGUE_TABLE_META_TITLE": "{x1} Table, Form & Standings from Oddschecker",
	"RESPONSIVE_LEAGUE_TABLE_PLAYED": "Played",
	"RESPONSIVE_LEAGUE_TABLE_PLAYED_SHORT": "P",
	"RESPONSIVE_LEAGUE_TABLE_POINTS": "Points",
	"RESPONSIVE_LEAGUE_TABLE_POINTS_SHORT": "Pts",
	"RESPONSIVE_LEAGUE_TABLE_TEAM": "Team",
	"RESPONSIVE_LEAGUE_TABLE_URL": "tables",
	"RESPONSIVE_LEAGUE_TABLE_VIEW": "View full table",
	"RESPONSIVE_LEAGUE_TABLE_VIEW_STAGES": "View all tables",
	"RESPONSIVE_LEAGUE_TABLE_WON": "Won",
	"RESPONSIVE_LEAGUE_TABLE_WON_SHORT": "W",
	"RESPONSIVE_LEARN_ABOUT_ODDSCHECKER": "Learn more about Oddschecker ",
	"RESPONSIVE_LEARN_MORE": "Learn More",
	"RESPONSIVE_LIMITED_TIME": "Limited time only!",
	"RESPONSIVE_LINK_COPIED": "COPIED",
	"RESPONSIVE_LINK_EXPIRED_SUBTITLE": "Request a new one",
	"RESPONSIVE_LINK_EXPIRED_TITLE": "The link has expired",
	"RESPONSIVE_LOADING_BETS": "We are loading your bets, and they will be here in a second.",
	"RESPONSIVE_LOADING_BETSLIP": "Loading Betslip",
	"RESPONSIVE_LOAD_ALL": "Load all",
	"RESPONSIVE_LOAD_MORE": "Load More",
	"RESPONSIVE_LOGOUT_SUCCESSFUL": "Logout Successful",
	"RESPONSIVE_LOG_IN": "Log In",
	"RESPONSIVE_LOG_IN_REGISTER": "RESPONSIVE_LOG_IN_REGISTER",
	"RESPONSIVE_LOG_OUT": "Log Out",
	"RESPONSIVE_LS_FILTER_COMPETITIONS": "Filter Competitions",
	"RESPONSIVE_LS_FIRST_HALF": "First Half",
	"RESPONSIVE_LS_FULL_TIME": "FT",
	"RESPONSIVE_LS_GOAL_SCORED": "Goal!",
	"RESPONSIVE_LS_H1": "Soccer Live Scores (BETA)",
	"RESPONSIVE_LS_HALF_TIME": "HT",
	"RESPONSIVE_LS_POSTPONED": "Postponed",
	"RESPONSIVE_LS_RUNNING": "IN-PLAY",
	"RESPONSIVE_LS_SECOND_HALF": "Second Half",
	"RESPONSIVE_MANAGE_SUBSCRIPTION": "Manage Subscription",
	"RESPONSIVE_MARKET_NAME_INCLUDING_DRAW_TO_OVERWRITE": "3-Way Moneyline",
	"RESPONSIVE_MARKET_NAME_TOTAL_AWAY_GOALS_TO_OVERWRITE": "Total Away Goals ( 60 mins )",
	"RESPONSIVE_MARKET_NAME_TOTAL_HOME_GOALS_TO_OVERWRITE": "Total Home Goals ( 60 mins )",
	"RESPONSIVE_MARKET_NAME_WINNER_TO_OVERWRITE": "Moneyline",
	"RESPONSIVE_MARKET_REPORTS_%1": "%1 Market Movers",
	"RESPONSIVE_MENU": "MENU",
	"RESPONSIVE_MENU_BACK": "RESPONSIVE_MENU_BACK",
	"RESPONSIVE_MONEYLINE": "MONEYLINE",
	"RESPONSIVE_MONTH": "MONTH",
	"RESPONSIVE_MORE": "More",
	"RESPONSIVE_MORE_BETS": "More Bets",
	"RESPONSIVE_MORE_MARKETS": "More Markets",
	"RESPONSIVE_MORE_RACES": "More Races",
	"RESPONSIVE_MORE_WAGERS": "More Odds",
	"RESPONSIVE_MOVER_FROM": "From",
	"RESPONSIVE_MOVER_INFO": "Selections in a betting market with the biggest odds cuts by individual bookmakers.",
	"RESPONSIVE_MOVER_TO": "To",
	"RESPONSIVE_MY_ACCOUNT": "My Account",
	"RESPONSIVE_MY_ODDSCHECKER": "My Oddschecker",
	"RESPONSIVE_NAME": "Name",
	"RESPONSIVE_NAVIGATION_ALLSPORTS": "RESPONSIVE_NAVIGATION_ALLSPORTS",
	"RESPONSIVE_NAV_PICK_MATCH": "Change Match",
	"RESPONSIVE_NAV_PICK_RACE": "Change Race",
	"RESPONSIVE_NAV_PICK_TRACK": "Change Track",
	"RESPONSIVE_NEWS": "Insights",
	"RESPONSIVE_NEWSLETTER_CHANGE_SUCCESS": "Newsletter preference updated",
	"RESPONSIVE_NEWSLETTER_SIGN_UP_SUCCESS": "Thanks! You'll get your first newsletter soon.",
	"RESPONSIVE_NEWSLETTER_UNSUBSCRIBED_MESSAGE": "Unsubscribed from newsletter",
	"RESPONSIVE_NEWSLETTER_YES": "I want to receive our exclusive newsletter",
	"RESPONSIVE_NEWS_ALL_CATEGORIES": "All News Categories",
	"RESPONSIVE_NEWS_HOME": "All betting news",
	"RESPONSIVE_NEWS_URL": "news",
	"RESPONSIVE_NEW_ARTICLES": "RESPONSIVE_NEW_ARTICLES",
	"RESPONSIVE_NEW_CUSTOMERS": "New Customers",
	"RESPONSIVE_NEW_CUSTOMER_FREE_BETS": "New Customer Free Bets",
	"RESPONSIVE_NEXT_%1_RACES": "Next %1 Races",
	"RESPONSIVE_NEXT_5_RACES": "Next 5 Races",
	"RESPONSIVE_NEXT_OFF": "Next Off",
	"RESPONSIVE_NEXT_RACE": "Next Race",
	"RESPONSIVE_NEXT_TIPS": "Next Tips",
	"RESPONSIVE_NEXT_UP": "Next Up",
	"RESPONSIVE_NEXT_UP_EVENTS": "Sports Betting - Next Up",
	"RESPONSIVE_NEXT_UP_GAMES": "Next up games",
	"RESPONSIVE_NOTHING_TO_SEE_HERE": "Nothing to see here",
	"RESPONSIVE_NOTIFY_ME": "Send me news, exclusive offers and expert tips",
	"RESPONSIVE_NOT_AVAILABLE": "N/A",
	"RESPONSIVE_NO_BETS_AVAILABLE": "There are no bets available at the moment",
	"RESPONSIVE_NO_DATA_AVAILABLE": "No Data Available",
	"RESPONSIVE_NO_EMAIL": "No e-mail?",
	"RESPONSIVE_NO_INTERACTION_TEXT": "The odds displaying for this event cannot be engaged-with or added to your betslip. They are for informational purposes only.",
	"RESPONSIVE_NO_MARKETS": "No markets currently available",
	"RESPONSIVE_NO_MATCHES": "No Matches",
	"RESPONSIVE_NO_ODDS": "No Odds",
	"RESPONSIVE_NO_ODDS_AVAILABLE": "Oh no! It seems there is no market data for this event. If you think this is a mistake, let us know ",
	"RESPONSIVE_NO_OTHER_MARKETS": "No other markets available",
	"RESPONSIVE_NO_RESULTS_AVAILABLE": "No results available",
	"RESPONSIVE_OC_HANDICAPPERS": "Expert Handicappers",
	"RESPONSIVE_OC_SEARCH": "Search Oddschecker",
	"RESPONSIVE_ODDS": "Odds",
	"RESPONSIVE_ODDSCHECKER_META_DATA": " | OddsChecker",
	"RESPONSIVE_ODDS_DRIFTING": "Odds Drifting",
	"RESPONSIVE_ODDS_FORMAT": "Odds format",
	"RESPONSIVE_ODDS_SHORTENING": "Odds Shortening",
	"RESPONSIVE_ODDS_STATIC": "Static Odds",
	"RESPONSIVE_OFFERS": "Offers",
	"RESPONSIVE_OFFERS_NO": "I do not want to receive exclusive offers and free bets",
	"RESPONSIVE_OFFERS_PAGE_LINK": "bonus-bets",
	"RESPONSIVE_OFFERTYPE_CASINO": "RESPONSIVE_OFFERTYPE_CASINO",
	"RESPONSIVE_OFFERTYPE_DEPOSIT": "RESPONSIVE_OFFERTYPE_DEPOSIT",
	"RESPONSIVE_OFFERTYPE_ENHANCED_ODDS": "RESPONSIVE_OFFERTYPE_ENHANCED_ODDS",
	"RESPONSIVE_OFFERTYPE_NO_DEPOSIT": "RESPONSIVE_OFFERTYPE_NO_DEPOSIT",
	"RESPONSIVE_OFFER_ALL_CUSTOMER": "All Customer Offer",
	"RESPONSIVE_OFFER_CASINO_NEW_CUSTOMER": "New Customer Offer",
	"RESPONSIVE_OFFER_ENHANCED_ODDS": "RESPONSIVE_OFFER_ENHANCED_ODDS",
	"RESPONSIVE_OFFER_NEW_CUSTOMER": "New Customer Offer",
	"RESPONSIVE_OFFER_SPINS": "RESPONSIVE_OFFER_SPINS",
	"RESPONSIVE_OFFER_UNSUBSCRIBED_MESSAGE": "Unsubscribed from offer emails",
	"RESPONSIVE_ONBOARDING_PRIMARY_BG_IMG": "types/LF0/responsive-onboarding-signup-nfl-us.jpg",
	"RESPONSIVE_ONBOARDING_SECONDARY_BG_IMG": "types/LF0/responsive-onboarding-signup-nba-us.jpg",
	"RESPONSIVE_ONE": "1",
	"RESPONSIVE_OPENING_ODDS": "Opening",
	"RESPONSIVE_OPEN_BETSLIP": "RESPONSIVE_OPEN_BETSLIP",
	"RESPONSIVE_OTHER_BOOKIES": "Other Bookmakers",
	"RESPONSIVE_OTHER_BOOKMAKERS": "Other Bookmakers",
	"RESPONSIVE_OTHER_LEAGUES": "Other Leagues",
	"RESPONSIVE_OTHER_MARKETS": "Other Markets",
	"RESPONSIVE_OTHER_OUTRIGHTS": "Other Outrights",
	"RESPONSIVE_OUR_PICK": "OUR PICK",
	"RESPONSIVE_OUTRIGHTS": "Outrights",
	"RESPONSIVE_OUTRIGHT_BETTING_%1": "%1 Futures",
	"RESPONSIVE_OUTSIDER": "The Outsider",
	"RESPONSIVE_OVERALL": "Overall",
	"RESPONSIVE_OVERALL_RATING": "Overall Rating",
	"RESPONSIVE_PAGE_%1": "Page %1",
	"RESPONSIVE_PAGE_NOT_FOUND": "RESPONSIVE_PAGE_NOT_FOUND",
	"RESPONSIVE_PAGE_NOT_FOUND_TEXT": "RESPONSIVE_PAGE_NOT_FOUND_TEXT",
	"RESPONSIVE_PAGINATION_NEXT": "RESPONSIVE_PAGINATION_NEXT",
	"RESPONSIVE_PAGINATION_PREV": "RESPONSIVE_PAGINATION_PREV",
	"RESPONSIVE_PASSWORD": "Password",
	"RESPONSIVE_PASSWORDS_NOT_MATCH": "Passwords do not match",
	"RESPONSIVE_PASSWORD_CHANGE_SUCCESS": "Password change successful.",
	"RESPONSIVE_PASSWORD_CURRENT_INVALID": "Invalid current password",
	"RESPONSIVE_PASSWORD_ERROR_MAX": "Password must be a maximum of 20 characters",
	"RESPONSIVE_PASSWORD_ERROR_MIN": "Password must be a minimum of 4 characters long",
	"RESPONSIVE_PASSWORD_HIDDEN": "Password (hidden)",
	"RESPONSIVE_PASSWORD_INVALID": "Password invalid",
	"RESPONSIVE_PASSWORD_LINK": "A link to reset your password has been sent to the email address you entered",
	"RESPONSIVE_PASSWORD_NEW": "RESPONSIVE_PASSWORD_NEW",
	"RESPONSIVE_PASSWORD_STRENGTH": "Password strength",
	"RESPONSIVE_PAYMENT_METHODS": "Payment Methods:",
	"RESPONSIVE_PAYMENT_SPEED": "Payment Speed:",
	"RESPONSIVE_PAYOUT_SPEED": "Payout Speed",
	"RESPONSIVE_PEOPLE_BETTING_ON": "People are betting on",
	"RESPONSIVE_PICK": "Oddschecker Pick",
	"RESPONSIVE_PICKS": "Picks",
	"RESPONSIVE_PICKS_AND_ANALYSIS_LINK_TEXT": "View Picks and Analysis",
	"RESPONSIVE_PICKS_CONTENT_LABEL": "Analysis",
	"RESPONSIVE_PICKS_OF_THE_WEEK": "Picks of the week",
	"RESPONSIVE_PICKS_URL": "<a title=\"Picks\" target=\"_blank\" href=\"https://www.stg.occloud.io/us/picks-parlays?ocpremium\">Sign Up For MyOC Premium!</a>",
	"RESPONSIVE_PICK_YOUR_STATE": "Pick Your State",
	"RESPONSIVE_PLACE": "Place",
	"RESPONSIVE_POPULAR_BETS": "Popular Bets",
	"RESPONSIVE_POPULAR_BETTING": "Popular Betting",
	"RESPONSIVE_POPULAR_BETTING_%1": "%1 Betting",
	"RESPONSIVE_POPULAR_EVENTS": "Popular Events",
	"RESPONSIVE_POPULAR_MARKETS": "Popular Markets",
	"RESPONSIVE_POPULAR_OUTRIGHTS": "Popular Outrights",
	"RESPONSIVE_POPULAR_SEARCHES": "Popular searches:",
	"RESPONSIVE_POPULAR_SPORTS": "Popular Sports",
	"RESPONSIVE_PREMIUM_CARD_BANNER_TITLE": "LOG IN TO VIEW FOR FREE",
	"RESPONSIVE_PREMIUM_FORM_BULLETPOINT_1_DESCRIPTION": "Exclusive picks from the industry's most profitable handicappers",
	"RESPONSIVE_PREMIUM_FORM_BULLETPOINT_1_TITLE": "Expert Picks",
	"RESPONSIVE_PREMIUM_FORM_BULLETPOINT_2_DESCRIPTION": "Game and player prediction AI models for every NFL matchup",
	"RESPONSIVE_PREMIUM_FORM_BULLETPOINT_2_TITLE": "System Projections",
	"RESPONSIVE_PREMIUM_FORM_BULLETPOINT_3_DESCRIPTION": "Our best-in-class experts have you covered with picks on the NBA, NCAAF, NHL, UFC, and more!",
	"RESPONSIVE_PREMIUM_FORM_BULLETPOINT_3_TITLE": "Daily Best Bets",
	"RESPONSIVE_PREMIUM_FORM_DUE_TODAY": "Due Today:",
	"RESPONSIVE_PREMIUM_FORM_FREE_TRIAL_CONDITIONS": "By signing up you are confirming that you're over 21 and agree to our Terms and Conditions (which include specific terms applicable to MYOC Premium) available to read <a href=\"https://oddschecker.com/us/terms-and-conditions\" target=\"_blank\">here</a> and our <a href=\"https://oddschecker.com/us/privacy\" target=\"_blank\">Privacy Policy</a>.",
	"RESPONSIVE_PREMIUM_FORM_FREE_TRIAL_TERMS": "By signing up for a MyOC Premium free trial you are agreeing to pay $%1 after the trial period ends. This plan will auto-renew %2 unless cancelled.",
	"RESPONSIVE_PREMIUM_FORM_ONE_TIME_PAYMENT": "One time payment",
	"RESPONSIVE_PREMIUM_FORM_PRIMARY_CTA_TEXT_FREE_TRIAL": "Start %1 day free trial",
	"RESPONSIVE_PREMIUM_FORM_PRIMARY_CTA_TEXT_LOGGED_IN": "Subscribe to premium",
	"RESPONSIVE_PREMIUM_FORM_PRIMARY_CTA_TEXT_LOGGED_OUT": "Create account",
	"RESPONSIVE_PREMIUM_FORM_SECONDARY_CTA_TEXT": "Winning is not for me",
	"RESPONSIVE_PREMIUM_FORM_SUBTITLE": "Log in or create a free account to score full picks and tools access",
	"RESPONSIVE_PREMIUM_FORM_SUBTITLE_FREE_TRIAL": "Log in or create a free account to score full picks and tools access",
	"RESPONSIVE_PREMIUM_FORM_TITLE": "Join the MYOC Roster!",
	"RESPONSIVE_PREMIUM_FORM_TITLE_FREE_TRIAL": "Join the MYOC Roster!",
	"RESPONSIVE_PREMIUM_LOCKED_BODY_CHANGE_PLAN": "False start. Your current MyOC Premium Plan doesn't give you access to this pick. Want to change your plan?",
	"RESPONSIVE_PREMIUM_LOCKED_BODY_FREE_TRIAL": "You're missing the best plays. Need the complete playbook? Access it now by logging in",
	"RESPONSIVE_PREMIUM_LOCKED_BODY_SIGN_UP": "You're missing the best plays. Need the complete playbook? Access it now by signing up.",
	"RESPONSIVE_PREMIUM_LOCKED_CTA_CONTACT_US": "Contact Us",
	"RESPONSIVE_PREMIUM_LOCKED_CTA_FREE_TRIAL": "Log in to view",
	"RESPONSIVE_PREMIUM_LOCKED_CTA_UPGRADE": "Upgrade to Premium",
	"RESPONSIVE_PREMIUM_PRODUCT_BANNER_TEXT": "Save $%1 per year",
	"RESPONSIVE_PREMIUM_PRODUCT_PRICE_INFO": "/month",
	"RESPONSIVE_PREMIUM_PRODUCT_PRICE_INFO_ANNUALLY": " billed annually",
	"RESPONSIVE_PREMIUM_PRODUCT_RECOMMENDED_FOOTER": "Best Value",
	"RESPONSIVE_PREMIUM_SUCCESS_CTA": "take me to premium",
	"RESPONSIVE_PREMIUM_SUCCESS_TITLE": "you've made the starting lineup!",
	"RESPONSIVE_PRIVACY_COOKIES": "Privacy & Cookies",
	"RESPONSIVE_PRIVACY_POLICY": "Privacy Policy",
	"RESPONSIVE_PRIVACY_POLICY_URL": "https://oddschecker.com/us/privacy",
	"RESPONSIVE_PRIVACY_REMINDER": "A privacy reminder from Oddschecker",
	"RESPONSIVE_PRIVACY_URL": "<a title=\"Privacy Policy\" target=\"_blank\" href=\"https://www.stg.occloud.io/us/privacy\">Privacy Policy</a>",
	"RESPONSIVE_PROBLEM_REQUEST": "There was a problem with your request, please try again later",
	"RESPONSIVE_PROFILE": "Profile",
	"RESPONSIVE_PROJECTIONS_LINK_TEXT": "View Projections and Data",
	"RESPONSIVE_PROJECTION_PAGE_TITLE": "projections and betting data",
	"RESPONSIVE_PROJECTION_PAGE_VIEW_ODDS": "View Matchup Odds",
	"RESPONSIVE_PROMO_CLICKOUT_LABEL": "Visit Site",
	"RESPONSIVE_PROMO_CODE": "Promo Code",
	"RESPONSIVE_QUICK_LINKS": "Quick Links",
	"RESPONSIVE_RACES_TEXT": "Races",
	"RESPONSIVE_RACE_%1": "R%1",
	"RESPONSIVE_RACE_DATE": "Date",
	"RESPONSIVE_RACE_DISTANCE": "Distance",
	"RESPONSIVE_RACE_FINISHED": "Race Finished",
	"RESPONSIVE_RACE_FORM": "Form",
	"RESPONSIVE_RACE_MEETING": "Meeting",
	"RESPONSIVE_RACE_NAME": "Race Name",
	"RESPONSIVE_RACE_PERFORMANCE_HISTORY": "Performance History",
	"RESPONSIVE_RACE_STATE": "State",
	"RESPONSIVE_RACING_NON_RUNNER": "Non Runner",
	"RESPONSIVE_RACING_PLACED": "Placed",
	"RESPONSIVE_RACING_RESULTS": "Result",
	"RESPONSIVE_RACING_RESULTS_PENDING": "Pending",
	"RESPONSIVE_RACING_WON": "Won",
	"RESPONSIVE_READ": "%1 read",
	"RESPONSIVE_READ_ARTICLE": "Read Article",
	"RESPONSIVE_READ_BOOKIE_REVIEW": "Read bookie review",
	"RESPONSIVE_READ_FULL_ARTICLE": "Read Full Article",
	"RESPONSIVE_READ_MORE": "Read more",
	"RESPONSIVE_READ_MORE_ABOUT_US": "Read more about us",
	"RESPONSIVE_REGISTRATION_%1": "RESPONSIVE_REGISTRATION_%1",
	"RESPONSIVE_RELATED_NEWS_TIPS": "Related Tips & News",
	"RESPONSIVE_RELATED_TIPS": "Related Tips",
	"RESPONSIVE_REMEMBER_DETAILS": "Remember my details",
	"RESPONSIVE_REMOVE": "Remove",
	"RESPONSIVE_REMOVE_FROM_BET_SLIP": "Remove from Bet Slip",
	"RESPONSIVE_REPORT_AVERAGE_MARKET_SWING": "Avg. Market Share Swing",
	"RESPONSIVE_REPORT_AVERAGE_MARKET_SWING_SHORT": "% Swing",
	"RESPONSIVE_REPORT_BEST_BOOK": "Best Book",
	"RESPONSIVE_REPORT_BEST_CURRENT_ODDS": "Best Current Odds",
	"RESPONSIVE_REPORT_BEST_CURRENT_ODDS_SHORT": "Best Odds",
	"RESPONSIVE_REPORT_BEST_ORIGINAL_ODDS": "Best Original Odds",
	"RESPONSIVE_REPORT_BET_TYPE": "Bet Type",
	"RESPONSIVE_REPORT_BOOKIES_ODDS_MOVED": "Bookies With Odds Moved",
	"RESPONSIVE_REPORT_BOOKIES_WITH_ODDS": "Bookies With Odds",
	"RESPONSIVE_REPORT_DIFFERENCE": "% Difference",
	"RESPONSIVE_REPORT_EVENT_NAME": "Event",
	"RESPONSIVE_REPORT_HIGH_ODDS": "High Odds",
	"RESPONSIVE_REPORT_LOW_ODDS": "Low Odds",
	"RESPONSIVE_REPORT_MOVED_BY": "Moved By",
	"RESPONSIVE_REPORT_NUMBER_OF_RUNNERS": "Number Of Runners",
	"RESPONSIVE_REPORT_OK_BUTTON": "Ok, Got it",
	"RESPONSIVE_REPORT_SHORTEST_CURRENT_ODDS": "Shortest Current Odds",
	"RESPONSIVE_REPUB": "United States",
	"RESPONSIVE_REPUB_LICENSED": "Licensed",
	"RESPONSIVE_REQUEST_NEW_PASSWORD": "Request New Password",
	"RESPONSIVE_RESEND_LINK": "RE-SEND LINK",
	"RESPONSIVE_RESET": "Reset",
	"RESPONSIVE_RESET_PASSWORD": "Reset Password",
	"RESPONSIVE_RESET_PASSWORD_TEXT": "Please reset your password below. It must be a minimum of 4 characters long.",
	"RESPONSIVE_RESULTS": "Result",
	"RESPONSIVE_RESULTS_META_TITLE": "Results",
	"RESPONSIVE_RESULTS_PENDING": "Pending",
	"RESPONSIVE_RETURNS": "Returns",
	"RESPONSIVE_REVIEW": "Review",
	"RESPONSIVE_REVIEW_NOW": "Review Now",
	"RESPONSIVE_REVIEW_TABLE_TITLE": "Key Details",
	"RESPONSIVE_RE_SUBSCRIBE_TO_PREMIUM": "Re-Subscribe to Premium",
	"RESPONSIVE_RUNNER_AGE": "Age",
	"RESPONSIVE_RUNNER_COLOUR": "Colour",
	"RESPONSIVE_RUNNER_FORM": "Form",
	"RESPONSIVE_RUNNER_GENDER": "Sex",
	"RESPONSIVE_SAVE": "Save",
	"RESPONSIVE_SCROLL_TO_TOP": "RESPONSIVE_SCROLL_TO_TOP",
	"RESPONSIVE_SEARCH": "Search",
	"RESPONSIVE_SEARCHTERM": "searchTerm",
	"RESPONSIVE_SEARCH_ANY_EVENT": "Search any event or sport ",
	"RESPONSIVE_SEARCH_BEST_PRICE": "The best price on every bet",
	"RESPONSIVE_SEARCH_LOADING": "Loading results...",
	"RESPONSIVE_SEARCH_NO_RESULTS": "No results to show...",
	"RESPONSIVE_SEARCH_RESULTS": "Results",
	"RESPONSIVE_SEARCH_RESULTS_FOR": "Results for",
	"RESPONSIVE_SECURED_AND_TRUSTED": "Secured & Trusted",
	"RESPONSIVE_SECURE_AND_TRUSTED": "Secure & Trusted",
	"RESPONSIVE_SEE_ALL_OFFERS": "See All Bonus Bets",
	"RESPONSIVE_SEE_REVIEW": "See review",
	"RESPONSIVE_SELECT_LANGUAGE": "RESPONSIVE_SELECT_LANGUAGE",
	"RESPONSIVE_SELECT_ODDS_FORMAT": "Select Odds Format",
	"RESPONSIVE_SELECT_STATE": "Please Select a State",
	"RESPONSIVE_SELECT_YOUR_STATE": "Select Your State",
	"RESPONSIVE_SETTINGS": "Settings",
	"RESPONSIVE_SET_STAKE": "Set stake",
	"RESPONSIVE_SHARE": "Share",
	"RESPONSIVE_SHARE_BET": "Share This Bet",
	"RESPONSIVE_SHARE_FACEBOOK": "RESPONSIVE_SHARE_FACEBOOK",
	"RESPONSIVE_SHARE_LINK": "RESPONSIVE_SHARE_LINK",
	"RESPONSIVE_SHARE_TELEGRAM": "RESPONSIVE_SHARE_TELEGRAM",
	"RESPONSIVE_SHARE_TWITTER": "RESPONSIVE_SHARE_TWITTER",
	"RESPONSIVE_SHORTEST_CURRENT_ODDS": "Shortest Current Odds",
	"RESPONSIVE_SHOW_ALL_LINES": "Show All Lines",
	"RESPONSIVE_SHOW_LESS": "Show Less",
	"RESPONSIVE_SHOW_MORE_LINES": "Show More Lines",
	"RESPONSIVE_SIGNED_UP": "CHECK YOUR INBOX",
	"RESPONSIVE_SIGNUP_SUCCESS": "Sign up Success",
	"RESPONSIVE_SIGN_IN": "Log In",
	"RESPONSIVE_SIGN_ME_UP": "SIGN ME UP",
	"RESPONSIVE_SIGN_UP": "Sign Up",
	"RESPONSIVE_SIGN_UP_NOW": "Sign Up Now",
	"RESPONSIVE_SIGN_UP_WITH_ODDSCHECKER": "Join the oddschecker Community",
	"RESPONSIVE_SIMILAR_ARTICLES": "Similar Articles",
	"RESPONSIVE_SINGLE_BET": "Single Bet",
	"RESPONSIVE_SOCIAL_LOGIN": "Or sign up with Facebook or Google",
	"RESPONSIVE_SOCIAL_LOGIN_OPTION": "Or sign up with Facebook or Google",
	"RESPONSIVE_SOCIAL_LOGIN_PROBLEM_1": "There was a problem signing you up.",
	"RESPONSIVE_SOCIAL_LOGIN_PROBLEM_2": "Unfortunately, we need your email address from {0} to sign you up for Oddschecker.",
	"RESPONSIVE_SOCIAL_LOGIN_TRY_AGAIN": "Try again with {0}",
	"RESPONSIVE_SORT_BY": "Sort By:",
	"RESPONSIVE_SORT_DIRECTION_ASC": "ASC",
	"RESPONSIVE_SORT_DIRECTION_DESC": "DESC",
	"RESPONSIVE_SORT_SPECIAL_OFFERS": "Special Offers:",
	"RESPONSIVE_SPECIAL_OFFERS": "Special Offers",
	"RESPONSIVE_SPLASH_TITLE": "RESPONSIVE_SPLASH_TITLE",
	"RESPONSIVE_SPORTS": "Sports",
	"RESPONSIVE_SPORTSBOOK": "Sportsbook",
	"RESPONSIVE_SPORTSBOOK_STATS_1": "Sportsbook",
	"RESPONSIVE_SPORTSBOOK_STATS_2": "Banking",
	"RESPONSIVE_SPORTSBOOK_STATS_3": "Bonuses",
	"RESPONSIVE_SPORTSBOOK_STATS_4": "Mobile app",
	"RESPONSIVE_SPORTS_BETTING_EXCHANGE_STATS_1": "SPORTS BETTING EXCHANGE",
	"RESPONSIVE_SPORTS_BETTING_LEGAL": "Sports Betting Legal",
	"RESPONSIVE_SPORTS_BETTING_LEGISLATION_PASSED": "Sports Betting Legislation Passed",
	"RESPONSIVE_SPORTS_BETTING_NOT_LEGAL": "Sports Betting Not Legal",
	"RESPONSIVE_SPORTS_ODDS": "Sports Odds",
	"RESPONSIVE_SPORT_BETTING_ODDS": "%1 Betting Odds",
	"RESPONSIVE_SPORT_FUTURES": "%1 Futures",
	"RESPONSIVE_SPORT_ODDS_COMPARISON": "%1 Betting Odds",
	"RESPONSIVE_SPORT_RESULTS": "%1 Results",
	"RESPONSIVE_SPREAD": "SPREAD",
	"RESPONSIVE_STAKE": "Stake",
	"RESPONSIVE_STAKE_RETURNS": "A ${0} stake could return ${1}",
	"RESPONSIVE_STAKE_SHORT": "Stake",
	"RESPONSIVE_STATE_LEGISLATION_NONE": "No legislation",
	"RESPONSIVE_STATE_LEGISLATION_PASSED": "Bill passed",
	"RESPONSIVE_STATE_LEGISLATION_PENDING": "Bill pending",
	"RESPONSIVE_STATE_LEGISLATION_TITLE": "State by State Legislation",
	"RESPONSIVE_STATE_NOT_SELECTED": "Please select a state",
	"RESPONSIVE_STATS": "Stats",
	"RESPONSIVE_STATS_AND_INSIGHT": "Stats and Insight",
	"RESPONSIVE_STEAMER_INFO": "Selections in a betting market with the biggest odds cuts by individual bookmakers. Excludes exchange Odds.",
	"RESPONSIVE_SUBSCRIBE_TO_EMAIL": "Sign-up for an oddschecker account to get expert picks, ai-driven betting tools and best odds across sportsbooks.",
	"RESPONSIVE_SUBSCRIBE_TO_PREMIUM": "Subscribe to Premium",
	"RESPONSIVE_SUBSCRIPTIONS": "Subscriptions",
	"RESPONSIVE_SUBSCRIPTIONS_CANCELLED_DETAIL": "We weren’t able to charge your card. Please update your payment method and resubscribe to MyOC Premium.",
	"RESPONSIVE_SUBSCRIPTIONS_CANCELLED_ON": "Cancelled on:",
	"RESPONSIVE_SUBSCRIPTIONS_CHANGES": "To make changes, ",
	"RESPONSIVE_SUBSCRIPTIONS_EXPIRED_ON": "Expired on:",
	"RESPONSIVE_SUBSCRIPTIONS_EXPIRES_FREE_TRIAL_LABEL": "Free Trial",
	"RESPONSIVE_SUBSCRIPTIONS_EXPIRES_ON": "Expires on:",
	"RESPONSIVE_SUBSCRIPTIONS_GO_TO_PORTAL": "go to your Stripe Portal.",
	"RESPONSIVE_SUBSCRIPTIONS_NO_SUBSCRIPTION_TEXT": "It doesn’t look like you have a subscription with us. Subscribe to MyOC Premium now to enjoy full premium picks and tools access.",
	"RESPONSIVE_SUBSCRIPTIONS_SETTINGS": "Subscription settings can only be changed within Stripe",
	"RESPONSIVE_SUB_MARKET_META": "%1 %2 | %3 | Oddschecker",
	"RESPONSIVE_TAKEOVER_CTA": "RESPONSIVE_TAKEOVER_CTA",
	"RESPONSIVE_TCS_APPLY": "T&Cs Apply",
	"RESPONSIVE_TEAMS": "Teams",
	"RESPONSIVE_TENNIS": "Tennis",
	"RESPONSIVE_TERMS_APPLY": "T&Cs",
	"RESPONSIVE_TERMS_CONDITIONS": "Terms & Conditions",
	"RESPONSIVE_TERMS_CONDITIONS_URL": "https://oddschecker.com/us/terms-and-conditions",
	"RESPONSIVE_TERMS_URL": "<a title=\"Terms and Conditions\" target=\"_blank\" href=\"https://www.stg.occloud.io/us/terms-and-conditions\">Terms and Conditions</a>",
	"RESPONSIVE_TEST": "Test",
	"RESPONSIVE_THANK_YOU_FOR_SIGNING_UP": "Thank you for signing up",
	"RESPONSIVE_TIMEZONE_CHANGE_SUCCESS": "RESPONSIVE_TIMEZONE_CHANGE_SUCCESS",
	"RESPONSIVE_TIME_FORMAT": "16:00",
	"RESPONSIVE_TIME_ZONE": "Time Zone",
	"RESPONSIVE_TIPS": "Picks and Parlays",
	"RESPONSIVE_TIPSTER": "Handicappers",
	"RESPONSIVE_TIPSTER_LOSSES": "Losses",
	"RESPONSIVE_TIPSTER_PUSH": "Push",
	"RESPONSIVE_TIPSTER_RECORD": "Record",
	"RESPONSIVE_TIPSTER_ROI": "ROI",
	"RESPONSIVE_TIPSTER_WINS": "Wins",
	"RESPONSIVE_TIPS_ALL_CATEGORIES": "All Tips Categories",
	"RESPONSIVE_TIPS_AND_NEWS": "Tips & News",
	"RESPONSIVE_TIPS_BY_CATEGORY": "%1 Betting Tips",
	"RESPONSIVE_TIPS_BY_CATEGORY_%1": "%1 Betting Tips",
	"RESPONSIVE_TIPS_HOME": "All betting tips",
	"RESPONSIVE_TIPS_TITLE": "picks-parlays",
	"RESPONSIVE_TIPS_URL": "picks-parlays",
	"RESPONSIVE_TODAY": "Today",
	"RESPONSIVE_TODAY_FIXTURES": "Today's Fixtures",
	"RESPONSIVE_TOMORROW": "Tomorrow",
	"RESPONSIVE_TOPDIFF_INFO": "Selections in a betting market with the highest odds variance between different bookmakers.  Excludes exchange Odds.",
	"RESPONSIVE_TOP_BETTING_SITES": "Top Betting Sites",
	"RESPONSIVE_TOP_BOOKMAKERS": "Featured Bookmakers",
	"RESPONSIVE_TOP_COMPETITIONS": "Top Competitions",
	"RESPONSIVE_TOTAL": "TOTAL",
	"RESPONSIVE_TOTAL_PAYOUT": "Total Payout",
	"RESPONSIVE_TOTAL_WIN": "Total Win",
	"RESPONSIVE_TO_BEAT_THE_ODDS": "Bet with Intelligence",
	"RESPONSIVE_TRY_AGAIN": "Oh dear! We couldn’t find what you’re looking for, please",
	"RESPONSIVE_TRY_AGAIN_BUTTON": "try again",
	"RESPONSIVE_TWO": "2",
	"RESPONSIVE_UNAVAILABLE": "Unavailable",
	"RESPONSIVE_UNLOCKED": "UNLOCKED",
	"RESPONSIVE_UPCOMING_RACES": "Upcoming Races",
	"RESPONSIVE_UPCOMING_TIPS": "Upcoming Tips",
	"RESPONSIVE_UPDATED_TCS": "We have changed our T&C's and updated our Cookie Policy.",
	"RESPONSIVE_URL_TO_REDIRECT_1": "boxing-mma/boxing|boxing",
	"RESPONSIVE_URL_TO_REDIRECT_2": "moto/nascar|baseball",
	"RESPONSIVE_USERNAME_EXISTS": "Username already exists",
	"RESPONSIVE_US_LICENSED": "US Licensed",
	"RESPONSIVE_VERIFICATION_EMAIL_SENT": "Click the link in the email we just sent you. The link expires in 48 hours.",
	"RESPONSIVE_VERIFICATION_EXPIRED": "The link has expired. Please enter your email below and request a new verification link.",
	"RESPONSIVE_VERIFICATION_PROMPT": "Click the button below to get a confirmation link sent to the email address you signed up with. The link expires in 48 hours.",
	"RESPONSIVE_VERIFICATION_SUCCESSFUL": "You're all set! Thanks for verifying your email address.",
	"RESPONSIVE_VIEW_ALL_ARTICLES": "View all articles",
	"RESPONSIVE_VIEW_ALL_GUIDES": "View All Guides",
	"RESPONSIVE_VIEW_ALL_MARKETS": "View All Markets",
	"RESPONSIVE_VIEW_ALL_MATCHES": "View All Matches",
	"RESPONSIVE_VIEW_ALL_PICKS": "View all picks",
	"RESPONSIVE_VIEW_ALL_RACES": "View All Races",
	"RESPONSIVE_VIEW_ALL_TEAMS": "View all Teams",
	"RESPONSIVE_VIEW_FULL_RACE_CARD": "View full race card",
	"RESPONSIVE_VIEW_LESS": "View Less",
	"RESPONSIVE_VIEW_LESS_TEAMS": "View less Teams",
	"RESPONSIVE_VIEW_MARKET": "View Market",
	"RESPONSIVE_VIEW_MORE": "View More",
	"RESPONSIVE_VIEW_MORE_GAMES": "View More Games",
	"RESPONSIVE_VIEW_MORE_HANDICAPPERS": "View More Handicappers",
	"RESPONSIVE_VIEW_MORE_ODDS": "View More Odds",
	"RESPONSIVE_VIEW_MORE_OUTRIGHTS": "View More Outrights",
	"RESPONSIVE_VIEW_MORE_SPORTS_HANDICAPPERS": "View More %1 Handicappers",
	"RESPONSIVE_VIEW_NEXT_FIXTURES": "View next fixtures",
	"RESPONSIVE_VIEW_OFFER": "View Offer",
	"RESPONSIVE_VIEW_PROFILE": "View profile",
	"RESPONSIVE_VIEW_TIPS": "View tips",
	"RESPONSIVE_WEDNESDAY": "Wednesday",
	"RESPONSIVE_WELCOME_AND_THANK_YOU": "It's official. You're on the team.  Pick your next play - no interceptions:",
	"RESPONSIVE_WINNER": "Winner",
	"RESPONSIVE_WINNINGS": "Returns",
	"RESPONSIVE_WORLD_CUP": "World Cup",
	"RESPONSIVE_YES_TO_TERMS": "I am over 21 and agree to the %1 and %2. I am happy to receive marketing and tips from OddsChecker.",
	"RESPONSIVE_YOUR_EMAIL_ADDRESS": "Your Email Address",
	"RESPONSIVE_YOUR_SELECTIONS": "Your Selections"
}
